'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getCurrentMonth = getCurrentMonth;
exports.getNextMonth = getNextMonth;
exports.getPrevMonth = getPrevMonth;
exports.generateCalendar = generateCalendar;
exports.sortDate = sortDate;
exports.findDate = findDate;
exports.toggleDate = toggleDate;
exports.get7 = get7;
exports.convertUserAvailability = convertUserAvailability;
exports.getMYFormat = getMYFormat;
exports.getDays = getDays;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var getAvailability = function getAvailability(availabilities, day) {
  if (!availabilities.some(function (availability) {
    return (0, _momentTimezone2.default)(availability.date).startOf('day').isSame(day, 'day');
  })) return { status: 'ask' };
  return availabilities.filter(function (a) {
    return (0, _momentTimezone2.default)(a.date).startOf('day').isSame(day, 'day');
  })[0];
};

function getCurrentMonth() {
  return (0, _momentTimezone2.default)().format('MMMM YYYY');
}

function getNextMonth(month) {
  var queryMonth = month ? (0, _momentTimezone2.default)(month, 'MMMM YYYY') : (0, _momentTimezone2.default)();
  return queryMonth.add(1, 'month').format('MMMM YYYY');
}

function getPrevMonth(month) {
  var queryMonth = month ? (0, _momentTimezone2.default)(month, 'MMMM YYYY') : (0, _momentTimezone2.default)();
  return queryMonth.add(-1, 'month').format('MMMM YYYY');
}

function generateCalendar(month, trip, availabilities) {
  var currentMonth = month;
  if (!currentMonth) {
    currentMonth = (0, _momentTimezone2.default)().format('MMMM YYYY');
  }
  var firstDay = (0, _momentTimezone2.default)(currentMonth, 'MMMM YYYY').startOf('month').startOf('day');
  var lastDay = (0, _momentTimezone2.default)(currentMonth, 'MMMM YYYY').endOf('month').startOf('day');
  var currentDay = firstDay;
  var dates = _lodash2.default.fill(new Array(firstDay.day()), {});
  while (!currentDay.isAfter(lastDay)) {
    var day = {
      day: currentDay.date(),
      date: currentDay.toDate()
    };
    var availability = {};
    if (availabilities) {
      availability = getAvailability(availabilities, currentDay);
    }
    if (currentDay.isSame((0, _momentTimezone2.default)(), 'day')) {
      day.today = true;
    }
    if (currentDay.isBefore((0, _momentTimezone2.default)().startOf('day'))) {
      day.passed = true;
      day.status = 'n/a';
    } else if (trip && trip.available_days && trip.available_days.length === 7 && !trip.available_days[currentDay.day()]) {
      day.status = 'n/a';
      day.tripNotOperate = true;
    } else {
      day.status = 'ask';
      if (trip && trip.user_id && trip.user_id.available_days && trip.user_id.available_days.length === 7 && trip.user_id.available_days[currentDay.day()] !== 'default') {
        day.status = trip.user_id.available_days[currentDay.day()];
        // AVAILABILITY VS USER
        // if (trip.is_unlimited_availability && trip.user_id.available_days[currentDay.day()] === 'n/a') {
        //   day.status = 'ask';
        // }
      }
      if (availabilities) {
        if (availability.booking_id) {
          day.status = 'n/a';
          day.booking_id = availability.booking_id;
        } else if (availability.status !== 'ask') {
          day.status = availability.status;
        }
      }
      if (trip && trip.hours_in_advance && (0, _momentTimezone2.default)().add(trip.hours_in_advance || 0, 'hour').isSameOrAfter(currentDay)) {
        // console.log(
        //   'hr in advance',
        //   moment().add(trip.hours_in_advance || 0, 'hour').toISOString(),
        //   currentDay.toISOString(),
        //   moment().add(trip.hours_in_advance || 0, 'hour').isSameOrAfter(currentDay),
        //   day.status
        // );
        if (trip.is_unbookable_in_advance) {
          day.passed = true;
          day.status = 'n/a';
        } else if (!trip.is_unbookable_in_advance && day.status === 'available') {
          day.status = 'ask';
        }
      }
      if (trip && trip.itinerary && trip.itinerary.length > 0) {
        var filteredItinerary = trip.itinerary.filter(function (i) {
          return i.time;
        }).sort(function (a, b) {
          // eslint-disable-line
          var aTime = (0, _momentTimezone2.default)(a.time, 'HH:mm');
          var bTime = (0, _momentTimezone2.default)(b.time, 'HH:mm');
          if (bTime.isBefore(aTime)) {
            return 1;
          }
          if (bTime.isSame(aTime)) {
            return 0;
          }
          return -1;
        });
        // const tripEnd = moment(
        //   filteredItinerary.length > 0 ? filteredItinerary[0].time : '',
        //   'HH:mm'
        // );
        var tripStart = (0, _momentTimezone2.default)(filteredItinerary.length > 0 ? filteredItinerary[0].time : '', 'HH:mm');
        if (currentDay.isSame((0, _momentTimezone2.default)(), 'day') &&
        // moment().startOf('day').date() === currentDay.date() &&
        (0, _momentTimezone2.default)().isSameOrAfter(tripStart)) {
          day.status = 'n/a';
          day.tripEndDay = true;
          // console.log('set to n/a', currentDay.toISOString());
        }
      }
      // if (trip && trip.is_unbookable_in_advance && moment().add(trip.hours_in_advance || 0, 'hour').isAfter(currentDay)) {
      //   day.passed = true;
      //   day.status = 'n/a';
      // } else if (day.status === 'available' && trip && trip.hours_in_advance && moment().add(trip.hours_in_advance, 'hour').isAfter(currentDay)) {
      //   day.status = 'ask';
      // }
    }
    // } else if (trip && trip.hours_in_advance && moment().add(trip.hours_in_advance, 'hour').isAfter(currentDay)) {
    //   day.status = 'ask';
    //   if (availability.booking_id || availability.status === 'n/a') {
    //     day.status = 'n/a';
    //     day.booking_id = availability.booking_id;
    //   }
    // } else if (availabilities) {
    //   if (availability.booking_id) {
    //     day.status = 'n/a';
    //     day.booking_id = availability.booking_id;
    //   } else {
    //     day.status = availability.status;
    //   }
    // } else {
    //   day.status = 'ask';
    // }

    dates.push(day);
    currentDay = currentDay.add(1, 'day');
  }
  return {
    prev: (0, _momentTimezone2.default)(currentMonth, 'MMMM YYYY').add(-1, 'month').format('MMMM YYYY'),
    next: (0, _momentTimezone2.default)(currentMonth, 'MMMM YYYY').add(1, 'month').format('MMMM YYYY'),
    current: currentMonth,
    days: dates.concat(_lodash2.default.fill(new Array(7 - lastDay.day() - 1), {}))
  };
}

function sortDate(dates) {
  return dates.sort(function (a, b) {
    return (0, _momentTimezone2.default)(a).unix() - (0, _momentTimezone2.default)(b).unix();
  });
}

function findDate(dates, date) {
  return _lodash2.default.findIndex(dates, function (eachDate) {
    return (0, _momentTimezone2.default)(eachDate).isSame(date, 'day');
  });
}

function toggleDate(dates, date) {
  var index = findDate(dates, date);
  return index < 0 ? sortDate([].concat((0, _toConsumableArray3.default)(dates), [date])) : _lodash2.default.filter(dates, function (d, i) {
    return i !== index;
  });
}

function get7(date) {
  return sortDate(_lodash2.default.times(7, function (i) {
    return (0, _momentTimezone2.default)(date).add(-i - 1, 'day').startOf('day').toDate();
  }).concat(_lodash2.default.times(7, function (i) {
    return (0, _momentTimezone2.default)(date).add(i + 1, 'day').startOf('day').toDate();
  }))).filter(function (filteringDate) {
    return !(0, _momentTimezone2.default)(filteringDate).isBefore((0, _momentTimezone2.default)());
  });
}

function convertUserAvailability(availabilities) {
  return availabilities.map(function (month) {
    return {
      month: month.current,
      availabilities: month.days.filter(function (day) {
        return !day.passed && !day.today && day.status !== 'ask' && !day.booking_id && !!day.date;
      }).map(function (day) {
        return {
          date: day.date,
          status: day.status
        };
      })
    };
  });
}

function getMYFormat() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  switch (locale) {
    case 'zh':
      return 'YYYY年 MMMM';
    case 'en':
      return 'MMMM YYYY';
    default:
      return 'MMMM YYYY';
  }
}

function getDays(month) {
  var firstDay = (0, _momentTimezone2.default)(month, 'MMMM YYYY').startOf('month').startOf('day');
  var lastDay = (0, _momentTimezone2.default)(month, 'MMMM YYYY').endOf('month').startOf('day');
  var days = _lodash2.default.range(firstDay.day()).fill(false);
  var currentDay = firstDay;
  while (!currentDay.isAfter(lastDay)) {
    days.push(currentDay.toDate());
    currentDay = currentDay.add(1, 'day');
  }
  return days.concat(_lodash2.default.range(6 - lastDay.day()).fill(false));
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/calendar.js
// module id = 155
// module chunks = 47